exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#ui-catalog-page[data-v-670b2179],.sideBar[data-v-670b2179]{height:100%}.sideBar[data-v-670b2179]{float:left;width:300px}.content[data-v-670b2179]{height:100%;overflow-y:auto;overflow-x:hidden}.bottomPlaceholder[data-v-670b2179]{height:100px}", ""]);

// exports
